import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AbstractDynamicInput } from '../abstract-dynamic-input';

@Component({
    selector: 'odq-dynamic-date',
    templateUrl: './dynamic-date.component.html',
    styleUrls: ['./dynamic-date.component.scss'],
    standalone: false
})
export class DynamicDateComponent extends AbstractDynamicInput {

  constructor(translate: TranslateService) { super(translate) }

  /**
  * Format Dates to handle strings
  */
  onDateChange($event) {
    var selectedDate = $event.value;
    if (selectedDate !== null && !isNaN(Date.parse(selectedDate))) {
      const formatedDate = new Date($event.value).toISOString();
      this.control.patchValue(formatedDate);
    }
  }
}
